/**
 * @generated SignedSource<<c7f67b9fa3204d7cd7d7d3d51551bf1e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRecommendationsRecommendationTile_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_user">;
  readonly " $fragmentType": "UserRecommendationsRecommendationTile_user";
};
export type UserRecommendationsRecommendationTile_user$key = {
  readonly " $data"?: UserRecommendationsRecommendationTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserRecommendationsRecommendationTile_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "showSeller",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f5dee1f88842f5c940bfc8ff8ab59674";

export default node;
